import { useGraphql } from 'utils/hooks/useGraphql';
import { UseMessageTypesHookOutput, UseMessageTypesQueryData } from './types';
import { DEFAULT_MESSAGE_TYPES, USE_MESSAGE_TYPES_HOOK_QUERY } from './constants';

export const useMessageTypes = (): UseMessageTypesHookOutput => {
  const {
    data,
    error: didError,
    isLoading,
  } = useGraphql<UseMessageTypesQueryData>(USE_MESSAGE_TYPES_HOOK_QUERY);
  return {
    messageTypes: data?.messageTypes ?? DEFAULT_MESSAGE_TYPES,
    didError,
    isLoading,
  };
};
